import { Table } from 'dexie';
import db, { DataRepository, Database, Key } from '@/db';
import { PutterWeight } from '../../api/models';

export type TABLE_TYPE = Table<PutterWeight>;

export const TABLE = 'putterWeight';
const SCHEMA = 'putterWeightId, sortId';

class PutterWeightDatabase implements DataRepository<PutterWeight> {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, SCHEMA);
  }

  get(key: Key): Promise<PutterWeight | undefined> {
    return this.db[TABLE].get(key);
  }

  delete(key: Key): Promise<void> {
    return this.db[TABLE].delete(key);
  }

  update(payload: PutterWeight, key: Key): Promise<PutterWeight> {
    return this.db[TABLE].put(payload, key);
  }

  async bulkAdd(payload: PutterWeight[]): Promise<PutterWeight[]> {
    await this.db[TABLE].clear();
    return this.db[TABLE].bulkPut(payload);
  }

  list(): Promise<PutterWeight[]> {
    return this.db[TABLE].orderBy('sortId').toArray();
  }
}

export const PutterWeightDB = new PutterWeightDatabase(db);
